import { Icon } from "@iconify/react";
import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Space,
  Steps,
  Typography,
  Upload,
  UploadProps,
  Checkbox,
  Image,
  message,
  Tooltip,
  Modal,
} from "antd";
import React, { useState, ReactNode, useEffect, useCallback, useMemo } from "react";
import { useNavigate, Link, useParams } from "react-router-dom";
import * as yup from "yup";
import { ContentWrapper, DataTable, PDFView, PDFViewer, WrapperCard } from "~/Components";
import styles from "../../Contract.module.scss";
import { ErrorMessage, Field, FieldProps, Formik } from "formik";
import { useAuth } from "~/Hooks/useAuth";
import { map } from "lodash";
import { useNotification } from "~/Hooks/useNotification";
import moment from "moment";
import upload from "@assets/SVG/upload.svg";
import { get, post, put } from "@services/api.service";
import { SuccessModal } from "@components/SuccessModal/SuccessModal";
import CustomOptions from "../../SubModules/CustomOptions/CustomOptions";
import { numberToWord } from "../../../../Utils/CommonUtils";
import { error } from "console";
import { allowedDomainsAll, UserType } from "~/Utils";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { animated, useSpring } from "react-spring";
import { HTML5Backend } from "react-dnd-html5-backend";
import { scrollToElement, scrollTop } from "@utils/CommonUtils";

interface FormItems {
  setSigningOrder: boolean;
  reviewMail: {
    emailSubject: String;
    emailMessage: string;
  };
  approveMail: {
    emailSubject: String;
    emailMessage: string;
  };
  completedMail: {
    emailSubject: String;
    emailMessage: string;
  };
  declineMail: {
    emailSubject: String;
    emailMessage: string;
  };
  reminderMail: {
    emailSubject: String;
    emailMessage: string;
  };
  copyMail: {
    emailSubject: String;
    emailMessage: string;
  };
  expiryMail: {
    emailSubject: String;
    emailMessage: string;
  };
  higherAuthorityMail: {
    emailSubject: String;
    emailMessage: string;
  };
  creatorMail: {
    emailSubject: String;
    emailMessage: string;
  };
  reSubmitMail: {
    emailSubject: String;
    emailMessage: string;
  };
  cancelMail: {
    emailSubject: String;
    emailMessage: string;
  };
  contracts?: any;
  templateName?: string;
  reminderEnabled?: boolean;
  reminderFrequency?: string;
  reminderDelay?: string;
  expiryAfter?: string;
  expiryWarn?: string;
  // signerCanSignOnMobile: boolean;
  recipientLock?: boolean;
  messageLock?: boolean;
  allowComments?: boolean;
}

const defaultValue = {
  reviewMail: {
    emailSubject: "",
    emailMessage: "",
  },
  approveMail: {
    emailSubject: "",
    emailMessage: "",
  },
  completedMail: {
    emailSubject: "",
    emailMessage: "",
  },
  declineMail: {
    emailSubject: "",
    emailMessage: "",
  },
  reminderMail: {
    emailSubject: "",
    emailMessage: "",
  },
  copyMail: {
    emailSubject: "",
    emailMessage: "",
  },
  expiryMail: {
    emailSubject: "",
    emailMessage: "",
  },
  higherAuthorityMail: {
    emailSubject: "",
    emailMessage: "",
  },
  creatorMail: {
    emailSubject: "",
    emailMessage: "",
  },
  reSubmitMail: {
    emailSubject: "",
    emailMessage: "",
  },
  cancelMail: {
    emailSubject: "",
    emailMessage: "",
  },
  templateName: "",
  reminderEnabled: "",
  reminderFrequency: "",
  reminderDelay: "",
  expiryAfter: "14",
  expiryWarn: "2",
  // signerCanSignOnMobile: true,
  recipientLock: false,
  messageLock: false,
  allowComments: true,
} as unknown as FormItems;

interface SignerItemProps {
  index: number;
  moveSigner: (from: number, to: number) => void;
  values: FormItems;
  setValues: (values: FormItems) => void;
}

const getItemText = (name: string, value: any, isBoolean?: any) => {
  return (
    <Space
      direction="vertical"
      style={{ marginBottom: styles.whitespace4 }}
    >
      <Typography.Text type="secondary">{name}</Typography.Text>
      <Typography.Text>{!isBoolean ? value : value ? "Enabled" : "Disabled"}</Typography.Text>
    </Space>
  );
};
const EqualCol = ({ children }: { children: ReactNode }) => (
  <Col
    xs={24}
    md={12}
  >
    {children}
  </Col>
);

var newDocId = 100;

export const AddNewTemplateDocument = () => {
  const [docsList, setDocsList] = useState<any>([]); // contains all files
  const { user } = useAuth();
  const { openToast, openNotification } = useNotification();
  const [currentStep, setCurrentStep] = useState(0);
  const [name, setName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [initialValue, setInitialValue] = useState<FormItems>(defaultValue);
  const [record, setRecord] = useState<any>({});
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [showSuccess, setShowSuccess] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState<any>("");
  const { id } = useParams();
  const [loadingDocId, setLoadingDocId] = useState<string>("");
  const [deletedIds, setDeletedIds] = useState<any>([]);
  const [selectDocument, setSelectDocument] = useState<any>();
  const [selectedDocumentReview, setSelectedDocumentReview] = useState<string>("");
  const [save, setSave] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const [scale, setScale] = useState<number>(1);

  const zoomIn = () => {
    setScale(scale + 0.1);
  };

  const zoomOut = () => {
    if (scale > 0.1) {
      setScale(scale - 0.1);
    }
  };

  useEffect(() => {
    if (id) {
      setIsLoading(true);
      get(`v1/spa/template-detail?templateId=${id}`)
        .then((res: any) => {
          res = res.response.data;
          setRecord(res);
          const values = {
            templateName: res.templateName,
            reviewMail: {
              emailSubject: res.reviewMail.emailSubject,
              emailMessage: res.reviewMail.emailMessage,
            },
            approveMail: {
              emailSubject: res.approveMail.emailSubject,
              emailMessage: res.approveMail.emailMessage,
            },
            completedMail: {
              emailSubject: res.completeMail.emailSubject,
              emailMessage: res.completeMail.emailMessage,
            },
            declineMail: {
              emailSubject: res.declineMail.emailSubject,
              emailMessage: res.declineMail.emailMessage,
            },
            reminderMail: {
              emailSubject: res.reminderMail.emailSubject,
              emailMessage: res.reminderMail.emailMessage,
            },
            copyMail: {
              emailSubject: res.copyMail.emailSubject,
              emailMessage: res.copyMail.emailMessage,
            },
            expiryMail: {
              emailSubject: res?.expiryMail?.emailSubject,
              emailMessage: res?.expiryMail?.emailMessage,
            },
            higherAuthorityMail: {
              emailSubject: res?.higherAuthorityMail?.emailSubject,
              emailMessage: res?.higherAuthorityMail?.emailMessage,
            },
            creatorMail: {
              emailSubject: res.creatorMail.emailSubject,
              emailMessage: res.creatorMail.emailMessage,
            },
            reSubmitMail: {
              emailSubject: res.reSubmitMail.emailSubject,
              emailMessage: res.reSubmitMail.emailMessage,
            },
            cancelMail: {
              emailSubject: res?.cancelMail?.emailSubject,
              emailMessage: res?.cancelMail?.emailMessage,
            },
            reminderEnabled: res.reminder.reminderEnabled,
            reminderFrequency: res.reminder.reminderFrequency,
            reminderDelay: res.reminder.reminderDelay,
            expiryAfter: res.expiration.expiryAfter,
            expiryWarn: res.expiration.expiryWarn,
            recipientLock: false,
            messageLock: false,
            allowComments: true,
          } as unknown as FormItems;
          setInitialValue(values);
          setIsLoading(false);
        })
        .catch(() => {
          openToast({
            content: "Getting data failed",
            type: "error",
          });
          setIsLoading(false);
        });
    }
  }, []);

  const convertToBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      if (file instanceof File) {
        const reader = new FileReader();
        reader.readAsDataURL(file as Blob);
        reader.onload = () => resolve(reader.result);
        ``;
        reader.onerror = (error) => reject(error);
      } else {
        resolve({});
      }
    });
  };

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [confirmAction, setConfirmAction] = useState<any>(null);

  const onSubmit = async (values: any) => {
    const payload: any = {
      templateName: values.templateName,
      reminder: {
        reminderEnabled: values.reminderEnabled,
        reminderFrequency: values.reminderFrequency,
        reminderDelay: values.reminderDelay,
      },
      expiration: {
        expiryAfter: values.expiryAfter,
        expiryWarn: values.expiryWarn,
        expiryEnabled: true,
      },
      defaultMail: {
        emailSubject: "test",
        emailMessage: "test",
      },
      reviewMail: {
        emailSubject: values.reviewMail.emailSubject,
        emailMessage: values.reviewMail.emailMessage,
      },
      approveMail: {
        emailSubject: values.approveMail.emailSubject,
        emailMessage: values.approveMail.emailMessage,
      },
      completedMail: {
        emailSubject: values.completedMail.emailSubject,
        emailMessage: values.completedMail.emailMessage,
      },
      declineMail: {
        emailSubject: values.declineMail.emailSubject,
        emailMessage: values.declineMail.emailMessage,
      },
      reminderMail: {
        emailSubject: values.reminderMail.emailSubject,
        emailMessage: values.reminderMail.emailMessage,
      },
      copyMail: {
        emailSubject: values.copyMail.emailSubject,
        emailMessage: values.copyMail.emailMessage,
      },
      expiryMail: {
        emailSubject: values?.expiryMail?.emailSubject,
        emailMessage: values?.expiryMail?.emailMessage,
      },
      higherAuthorityMail: {
        emailSubject: values?.higherAuthorityMail?.emailSubject,
        emailMessage: values?.higherAuthorityMail?.emailMessage,
      },
      reSubmitMail: {
        emailSubject: values.reSubmitMail.emailSubject,
        emailMessage: values.reSubmitMail.emailMessage,
      },
      cancelMail: {
        emailSubject: values.cancelMail.emailSubject,
        emailMessage: values.cancelMail.emailMessage,
      },
      creatorMail: {
        emailSubject: values.creatorMail.emailSubject,
        emailMessage: values.creatorMail.emailMessage,
      },
    };

    const formData = new FormData();
    formData.append("body", JSON.stringify(payload));
    if (id) {
      setConfirmAction(() => () => updateTemplate(id, payload));
      setIsModalVisible(true);
    } else {
      post(`v1/spa/create-template`, payload)
        .then((res: any) => {
          setSuccessOpen(true);
          setShowSuccess(true);
          setName(values.templateName);
          setIsSubmitLoading(false);
        })
        .catch((err) => {
          openNotification({
            title: err,
            message: "Template Creation failed",
            type: "error",
          });
          setIsSubmitLoading(false);
        });
    }
  };

  const updateTemplate = (id: any, payload: any) => {
    setIsSubmitLoading(true);
    put(`v1/spa/update-template/${id}`, payload)
      .then((res) => {
        if (res) {
          setSuccessOpen(true);
        }
        setIsSubmitLoading(false);
      })
      .catch((err) => {
        openNotification({
          title: err,
          message: "Template Updating failed",
          type: "error",
        });
        setIsSubmitLoading(false);
      });
  };

  const handleOk = () => {
    setIsSubmitLoading(true);
    if (confirmAction) confirmAction();
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setIsSubmitLoading(false);
  };

  const handleRemove = (file: any) => {
    if (!file.isNew) {
      setDeletedIds([...deletedIds, file.documentId]);
    }
    const index = docsList.findIndex((doc: any) => doc.documentId === file.documentId);
    const newFileList = [...docsList];
    newFileList.splice(index, 1);
    setDocsList(newFileList);
    if (file.name === selectDocument?.name || null) {
      setSelectDocument(null); // Set selectDocument to null
    } else {
      setSelectDocument(selectDocument); // Keep the selectDocument unchanged
    }
  };

  const handleFileChange = async (info: any) => {
    const { file, documentId } = info;
    try {
      const base64String: any = await convertToBase64(file);
      const documentBase64 = base64String.toString().split(",")[1];
      const newFile = {
        documentBase64: documentBase64,
        documentId: `${documentId}`,
        fileExtension: file.type?.split("/")[1],
        name: file.name.split(".")[0],
        isNew: true,
        file: file,
      };
      const totalSize = docsList?.map((item: any) => item);
      if (totalSize.length < 8) {
        setDocsList((prevList: any) => [...prevList, newFile]);
      } else {
        message.error("Adding the file exceeds the limit");
      }
    } catch (error) {
      console.error("Error converting file to base64:", error);
    }
  };

  const uploadProps: UploadProps = {
    onRemove: (file) => handleRemove(file),
    onChange: (info: any) => {
      info.documentId = newDocId;
      if (info.file.type === "application/pdf") {
        if (info.file.size <= 25 * 1024 * 1024) {
          handleFileChange(info);
        } else {
          message.error("Adding the file exceeds the 25 MB limit");
        }
      } else {
        message.error("Incorrect format, only PDF files are allowed");
      }
    },
    beforeUpload: (file) => {
      // handleFileChange(file);
      return false;
    },
  };

  const emailValidationSchema = yup.object().shape({
    emailSubject: yup.string().strict(true).required("Email Subject required"),
    emailMessage: yup.string().strict(true).required("Email Message required"),
  });

  const validationSchema1 = yup.object().shape({
    templateName: yup.string().required("Template Name required"),
    reviewMail: emailValidationSchema,
    approveMail: emailValidationSchema,
    completedMail: emailValidationSchema,
    declineMail: emailValidationSchema,
    reminderMail: emailValidationSchema,
    copyMail: emailValidationSchema,
    expiryMail: emailValidationSchema,
    higherAuthorityMail: emailValidationSchema,
    creatorMail: emailValidationSchema,
    reSubmitMail: emailValidationSchema,
    cancelMail: emailValidationSchema,
  });
  const validationSchema2 = yup.object().shape({
    signers: yup
      .array()
      .of(
        yup.object().shape({
          name: yup
            .string()
            .trim("Name cannot include leading and trailing spaces")
            .strict(true)
            .required("Name required")
            .matches(/^[a-zA-Z\s@'/]+$/, "Invalid Name"),
          // .matches(new RegExp(/^[\w'\-,.][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,}$/), "Invalid Name"),
          email: yup
            .string()
            .strict(true)
            .trim("Email address cannot include leading and trailing spaces")
            .lowercase("Email address must be a lowercase")
            .email("Email address must be a valid email")
            .required("Email address required")
            .matches(
              new RegExp(`^[a-zA-Z0-9._%+-]+@(${allowedDomainsAll.join("|")})$`),
              `Permitted Domains: ${allowedDomainsAll.join(", ")}`
            ),
        })
      )
      .test({
        test: function (signers) {
          const emailMap = new Map();
          const duplicateEmails = new Set();
          if (signers && signers.length > 0) {
            signers.forEach((signer) => {
              const { email } = signer;
              if (emailMap.has(email)) {
                duplicateEmails.add(email);
              }
              emailMap.set(email, (emailMap.get(email) || 0) + 1);
            });
          }
          if (duplicateEmails.size > 0) {
            const errors = [];
            for (let i = 0; i < (signers || []).length; i++) {
              const signer = (signers || [])[i];
              const { email } = signer;
              if (emailMap.get(email) > 1) {
                errors.push(
                  this.createError({
                    message: "Duplicate email found",
                    path: `signers[${i}].email`,
                  })
                );
              }
            }
            if (errors.length > 0) {
              throw new yup.ValidationError(errors);
            }
          }
          return true;
        },
      }),
    // .test({
    //   test: function (signers: any) {
    //     const emailMap = new Map();
    //     const duplicateEmails = new Set();
    //
    //     for (const signer of signers) {
    //       const { email } = signer;
    //
    //       if (emailMap.has(email)) {
    //         duplicateEmails.add(email);
    //       }
    //
    //       emailMap.set(email, (emailMap.get(email) || 0) + 1);
    //     }
    //
    //     if (duplicateEmails.size > 0) {
    //       const errors = [];
    //
    //       for (let i = 0; i < signers.length; i++) {
    //         const signer = signers[i];
    //         const { email } = signer;
    //
    //         if (emailMap.get(email) > 1) {
    //           errors.push(
    //             this.createError({
    //               message: "Duplicate email found",
    //               path: `signers[${i}].email`,
    //             })
    //           );
    //         }
    //       }
    //
    //       if (errors.length > 0) {
    //         throw new yup.ValidationError(errors);
    //       }
    //     }
    //
    //     return true;
    //   },
    // }),
  });
  const validationSchema = useMemo(() => {
    if (currentStep === 0) {
      return validationSchema1;
    } else {
      return validationSchema2;
    }
  }, [currentStep]);

  return (
    <>
      <ContentWrapper
        loading={isLoading}
        customTitle={
          <Space align="start">
            <Icon
              onClick={() => navigate(-1)}
              icon="akar-icons:arrow-left"
              style={{
                fontSize: "1.8rem",
                cursor: "pointer",
                color: styles.primary,
                marginRight: styles.whitespace1,
              }}
            />
            <span>
              <Typography.Title
                level={3}
                style={{ margin: 0 }}
              >
                {id ? "Edit" : "Create"} Template
              </Typography.Title>
            </span>
          </Space>
        }
      >
        <Formik
          initialValues={initialValue}
          onSubmit={(values) => onSubmit(values)}
          validationSchema={validationSchema}
        >
          {(props) => {
            return (
              <>
                <CustomOptions
                  setOpen={setOpen}
                  open={open}
                  setSave={setSave}
                  {...props}
                />{" "}
                <Form
                  layout="vertical"
                  onFinish={props.handleSubmit}
                >
                  <Row style={{ marginTop: 16 }}>
                    <Col
                      xs={24}
                      md={currentStep === 3 || currentStep === 1 ? 24 : 16}
                    >
                      {currentStep === 0 && (
                        <>
                          <div id="step1">
                            <Row>
                              <Col span={12}>
                                <div style={{ textAlign: "left" }}>
                                  <Typography.Title
                                    level={4}
                                    style={{ marginBottom: styles.whitesapce3 }}
                                  >
                                    Template Details
                                  </Typography.Title>
                                </div>
                              </Col>
                              <Col span={12}>
                                <div style={{ textAlign: "right" }}>
                                  <Button
                                    type="default"
                                    onClick={() => setOpen(true)}
                                    icon={
                                      save ? (
                                        <Icon
                                          icon={"subway:tick"}
                                          style={{ marginRight: styles.whitespace1 }}
                                        />
                                      ) : (
                                        ""
                                      )
                                    }
                                  >
                                    Custom Options
                                  </Button>
                                </div>
                              </Col>
                            </Row>

                            <Row
                              align="top"
                              style={{ marginBottom: styles.whitespace3 }}
                            >
                              <Col span={24}>
                                <Form.Item label="Template Name">
                                  <Field name={`templateName`}>
                                    {({ field }: FieldProps) => (
                                      <Input
                                        {...field}
                                        status={
                                          (props.touched.templateName && props.errors.templateName && "error") || ""
                                        }
                                      />
                                    )}
                                  </Field>
                                  <Typography.Text type="danger">
                                    <ErrorMessage name={`templateName`} />
                                  </Typography.Text>
                                </Form.Item>
                                <Typography.Title
                                  level={5}
                                  style={{ fontWeight: "bold" }}
                                >
                                  Review
                                </Typography.Title>
                                <Form.Item>
                                  <Typography.Title
                                    level={5}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    Email Subject
                                  </Typography.Title>
                                  <Field name={`reviewMail.emailSubject`}>
                                    {({ field }: FieldProps) => (
                                      <Input
                                        maxLength={1000}
                                        showCount
                                        {...field}
                                        status={
                                          (props.touched.reviewMail?.emailSubject &&
                                            props.errors.reviewMail?.emailSubject &&
                                            "error") ||
                                          ""
                                        }
                                      />
                                    )}
                                  </Field>
                                  <Typography.Text type="danger">
                                    <ErrorMessage name={`reviewMail.emailSubject`} />
                                  </Typography.Text>
                                  <div style={{ marginBottom: "16px" }} />
                                  <Typography.Title
                                    level={5}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    Email Message
                                  </Typography.Title>
                                  <Field name={`reviewMail.emailMessage`}>
                                    {({ field }: FieldProps) => (
                                      <Input.TextArea
                                        rows={8}
                                        showCount
                                        maxLength={1000}
                                        style={{ height: "100px" }}
                                        {...field}
                                        status={
                                          (props.touched.reviewMail?.emailMessage &&
                                            props.errors.reviewMail?.emailMessage &&
                                            "error") ||
                                          ""
                                        }
                                      />
                                    )}
                                  </Field>
                                  <Typography.Text type="danger">
                                    <ErrorMessage name={`reviewMail.emailMessage`} />
                                  </Typography.Text>
                                </Form.Item>

                                <Typography.Title
                                  level={5}
                                  style={{ fontWeight: "bold" }}
                                >
                                  Approval
                                </Typography.Title>
                                <Form.Item>
                                  <Typography.Title
                                    level={5}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    Email Subject
                                  </Typography.Title>
                                  <Field name={`approveMail.emailSubject`}>
                                    {({ field }: FieldProps) => (
                                      <Input
                                        maxLength={1000}
                                        showCount
                                        {...field}
                                        status={
                                          (props.touched.approveMail?.emailSubject &&
                                            props.errors.approveMail?.emailSubject &&
                                            "error") ||
                                          ""
                                        }
                                      />
                                    )}
                                  </Field>
                                  <Typography.Text type="danger">
                                    <ErrorMessage name={`approveMail.emailSubject`} />
                                  </Typography.Text>
                                  <div style={{ marginBottom: "16px" }} />
                                  <Typography.Title
                                    level={5}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    Email Message
                                  </Typography.Title>
                                  <Field name={`approveMail.emailMessage`}>
                                    {({ field }: FieldProps) => (
                                      <Input.TextArea
                                        rows={8}
                                        showCount
                                        maxLength={1000}
                                        style={{ height: "100px" }}
                                        {...field}
                                        status={
                                          (props.touched.approveMail?.emailMessage &&
                                            props.errors.approveMail?.emailMessage &&
                                            "error") ||
                                          ""
                                        }
                                      />
                                    )}
                                  </Field>
                                  <Typography.Text type="danger">
                                    <ErrorMessage name={`approveMail.emailMessage`} />
                                  </Typography.Text>
                                </Form.Item>

                                <Typography.Title
                                  level={5}
                                  style={{ fontWeight: "bold" }}
                                >
                                  Completed
                                </Typography.Title>
                                <Form.Item>
                                  <Typography.Title
                                    level={5}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    Email Subject
                                  </Typography.Title>
                                  <Field name={`completedMail.emailSubject`}>
                                    {({ field }: FieldProps) => (
                                      <Input
                                        maxLength={1000}
                                        showCount
                                        {...field}
                                        status={
                                          (props.touched.completedMail?.emailSubject &&
                                            props.errors.completedMail?.emailSubject &&
                                            "error") ||
                                          ""
                                        }
                                      />
                                    )}
                                  </Field>
                                  <Typography.Text type="danger">
                                    <ErrorMessage name={`completedMail.emailSubject`} />
                                  </Typography.Text>
                                  <div style={{ marginBottom: "16px" }} />
                                  <Typography.Title
                                    level={5}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    Email Message
                                  </Typography.Title>
                                  <Field name={`completedMail.emailMessage`}>
                                    {({ field }: FieldProps) => (
                                      <Input.TextArea
                                        rows={8}
                                        showCount
                                        maxLength={1000}
                                        style={{ height: "100px" }}
                                        {...field}
                                        status={
                                          (props.touched.completedMail?.emailMessage &&
                                            props.errors.completedMail?.emailMessage &&
                                            "error") ||
                                          ""
                                        }
                                      />
                                    )}
                                  </Field>
                                  <Typography.Text type="danger">
                                    <ErrorMessage name={`completedMail.emailMessage`} />
                                  </Typography.Text>
                                </Form.Item>

                                <Typography.Title
                                  level={5}
                                  style={{ fontWeight: "bold" }}
                                >
                                  Decline
                                </Typography.Title>
                                <Form.Item>
                                  <Typography.Title
                                    level={5}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    Email Subject
                                  </Typography.Title>
                                  <Field name={`declineMail.emailSubject`}>
                                    {({ field }: FieldProps) => (
                                      <Input
                                        maxLength={1000}
                                        showCount
                                        {...field}
                                        status={
                                          (props.touched.declineMail?.emailSubject &&
                                            props.errors.declineMail?.emailSubject &&
                                            "error") ||
                                          ""
                                        }
                                      />
                                    )}
                                  </Field>
                                  <Typography.Text type="danger">
                                    <ErrorMessage name={`declineMail.emailSubject`} />
                                  </Typography.Text>
                                  <div style={{ marginBottom: "16px" }} />
                                  <Typography.Title
                                    level={5}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    Email Message
                                  </Typography.Title>
                                  <Field name={`declineMail.emailMessage`}>
                                    {({ field }: FieldProps) => (
                                      <Input.TextArea
                                        rows={8}
                                        showCount
                                        maxLength={1000}
                                        style={{ height: "100px" }}
                                        {...field}
                                        status={
                                          (props.touched.declineMail?.emailMessage &&
                                            props.errors.declineMail?.emailMessage &&
                                            "error") ||
                                          ""
                                        }
                                      />
                                    )}
                                  </Field>
                                  <Typography.Text type="danger">
                                    <ErrorMessage name={`declineMail.emailMessage`} />
                                  </Typography.Text>
                                </Form.Item>

                                <Typography.Title
                                  level={5}
                                  style={{ fontWeight: "bold" }}
                                >
                                  Reminder Email
                                </Typography.Title>
                                <Form.Item>
                                  <Typography.Title
                                    level={5}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    Email Subject
                                  </Typography.Title>
                                  <Field name={`reminderMail.emailSubject`}>
                                    {({ field }: FieldProps) => (
                                      <Input
                                        maxLength={1000}
                                        showCount
                                        {...field}
                                        status={
                                          (props.touched.reminderMail?.emailSubject &&
                                            props.errors.reminderMail?.emailSubject &&
                                            "error") ||
                                          ""
                                        }
                                      />
                                    )}
                                  </Field>
                                  <Typography.Text type="danger">
                                    <ErrorMessage name={`reminderMail.emailSubject`} />
                                  </Typography.Text>
                                  <div style={{ marginBottom: "16px" }} />
                                  <Typography.Title
                                    level={5}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    Email Message
                                  </Typography.Title>
                                  <Field name={`reminderMail.emailMessage`}>
                                    {({ field }: FieldProps) => (
                                      <Input.TextArea
                                        rows={8}
                                        showCount
                                        maxLength={1000}
                                        style={{ height: "100px" }}
                                        {...field}
                                        status={
                                          (props.touched.reminderMail?.emailMessage &&
                                            props.errors.reminderMail?.emailMessage &&
                                            "error") ||
                                          ""
                                        }
                                      />
                                    )}
                                  </Field>
                                  <Typography.Text type="danger">
                                    <ErrorMessage name={`reminderMail.emailMessage`} />
                                  </Typography.Text>
                                </Form.Item>

                                <Typography.Title
                                  level={5}
                                  style={{ fontWeight: "bold" }}
                                >
                                  Copy
                                </Typography.Title>
                                <Form.Item>
                                  <Typography.Title
                                    level={5}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    Email Subject
                                  </Typography.Title>
                                  <Field name={`copyMail.emailSubject`}>
                                    {({ field }: FieldProps) => (
                                      <Input
                                        maxLength={1000}
                                        showCount
                                        {...field}
                                        status={
                                          (props.touched.copyMail?.emailSubject &&
                                            props.errors.copyMail?.emailSubject &&
                                            "error") ||
                                          ""
                                        }
                                      />
                                    )}
                                  </Field>
                                  <Typography.Text type="danger">
                                    <ErrorMessage name={`copyMail.emailSubject`} />
                                  </Typography.Text>
                                  <div style={{ marginBottom: "16px" }} />
                                  <Typography.Title
                                    level={5}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    Email Message
                                  </Typography.Title>
                                  <Field name={`copyMail.emailMessage`}>
                                    {({ field }: FieldProps) => (
                                      <Input.TextArea
                                        rows={8}
                                        showCount
                                        maxLength={1000}
                                        style={{ height: "100px" }}
                                        {...field}
                                        status={
                                          (props.touched.copyMail?.emailMessage &&
                                            props.errors.copyMail?.emailMessage &&
                                            "error") ||
                                          ""
                                        }
                                      />
                                    )}
                                  </Field>
                                  <Typography.Text type="danger">
                                    <ErrorMessage name={`copyMail.emailMessage`} />
                                  </Typography.Text>
                                </Form.Item>
                                <Typography.Title
                                  level={5}
                                  style={{ fontWeight: "bold" }}
                                >
                                  Expiry Email
                                </Typography.Title>
                                <Form.Item>
                                  <Typography.Title
                                    level={5}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    Email Subject
                                  </Typography.Title>
                                  <Field name={`expiryMail.emailSubject`}>
                                    {({ field }: FieldProps) => (
                                      <Input
                                        maxLength={1000}
                                        showCount
                                        {...field}
                                        status={
                                          (props.touched.expiryMail?.emailSubject &&
                                            props.errors.expiryMail?.emailSubject &&
                                            "error") ||
                                          ""
                                        }
                                      />
                                    )}
                                  </Field>
                                  <Typography.Text type="danger">
                                    <ErrorMessage name={`expiryMail.emailSubject`} />
                                  </Typography.Text>
                                  <div style={{ marginBottom: "16px" }} />
                                  <Typography.Title
                                    level={5}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    Email Message
                                  </Typography.Title>
                                  <Field name={`expiryMail.emailMessage`}>
                                    {({ field }: FieldProps) => (
                                      <Input.TextArea
                                        rows={8}
                                        showCount
                                        maxLength={1000}
                                        style={{ height: "100px" }}
                                        {...field}
                                        status={
                                          (props.touched.expiryMail?.emailMessage &&
                                            props.errors.expiryMail?.emailMessage &&
                                            "error") ||
                                          ""
                                        }
                                      />
                                    )}
                                  </Field>
                                  <Typography.Text type="danger">
                                    <ErrorMessage name={`expiryMail.emailMessage`} />
                                  </Typography.Text>
                                </Form.Item>
                                <Typography.Title
                                  level={5}
                                  style={{ fontWeight: "bold" }}
                                >
                                  Higher Authority Email
                                </Typography.Title>
                                <Form.Item>
                                  <Typography.Title
                                    level={5}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    Email Subject
                                  </Typography.Title>
                                  <Field name={`higherAuthorityMail.emailSubject`}>
                                    {({ field }: FieldProps) => (
                                      <Input
                                        maxLength={1000}
                                        showCount
                                        {...field}
                                        status={
                                          (props.touched.higherAuthorityMail?.emailSubject &&
                                            props.errors.higherAuthorityMail?.emailSubject &&
                                            "error") ||
                                          ""
                                        }
                                      />
                                    )}
                                  </Field>
                                  <Typography.Text type="danger">
                                    <ErrorMessage name={`higherAuthorityMail.emailSubject`} />
                                  </Typography.Text>
                                  <div style={{ marginBottom: "16px" }} />
                                  <Typography.Title
                                    level={5}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    Email Message
                                  </Typography.Title>
                                  <Field name={`higherAuthorityMail.emailMessage`}>
                                    {({ field }: FieldProps) => (
                                      <Input.TextArea
                                        rows={8}
                                        showCount
                                        maxLength={1000}
                                        style={{ height: "100px" }}
                                        {...field}
                                        status={
                                          (props.touched.higherAuthorityMail?.emailMessage &&
                                            props.errors.higherAuthorityMail?.emailMessage &&
                                            "error") ||
                                          ""
                                        }
                                      />
                                    )}
                                  </Field>
                                  <Typography.Text type="danger">
                                    <ErrorMessage name={`higherAuthorityMail.emailMessage`} />
                                  </Typography.Text>
                                </Form.Item>
                                <Typography.Title
                                  level={5}
                                  style={{ fontWeight: "bold" }}
                                >
                                  SPA Creator Email
                                </Typography.Title>
                                <Form.Item>
                                  <Typography.Title
                                    level={5}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    Email Subject
                                  </Typography.Title>
                                  <Field name={`creatorMail.emailSubject`}>
                                    {({ field }: FieldProps) => (
                                      <Input
                                        maxLength={1000}
                                        showCount
                                        {...field}
                                        status={
                                          (props.touched.creatorMail?.emailSubject &&
                                            props.errors.creatorMail?.emailSubject &&
                                            "error") ||
                                          ""
                                        }
                                      />
                                    )}
                                  </Field>
                                  <Typography.Text type="danger">
                                    <ErrorMessage name={`creatorMail.emailSubject`} />
                                  </Typography.Text>
                                  <div style={{ marginBottom: "16px" }} />
                                  <Typography.Title
                                    level={5}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    Email Message
                                  </Typography.Title>
                                  <Field name={`creatorMail.emailMessage`}>
                                    {({ field }: FieldProps) => (
                                      <Input.TextArea
                                        rows={8}
                                        showCount
                                        maxLength={1000}
                                        style={{ height: "100px" }}
                                        {...field}
                                        status={
                                          (props.touched.creatorMail?.emailMessage &&
                                            props.errors.creatorMail?.emailMessage &&
                                            "error") ||
                                          ""
                                        }
                                      />
                                    )}
                                  </Field>
                                  <Typography.Text type="danger">
                                    <ErrorMessage name={`creatorMail.emailMessage`} />
                                  </Typography.Text>
                                </Form.Item>
                                <Typography.Title
                                  level={5}
                                  style={{ fontWeight: "bold" }}
                                >
                                  Re-Submit Email
                                </Typography.Title>
                                <Form.Item>
                                  <Typography.Title
                                    level={5}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    Email Subject
                                  </Typography.Title>
                                  <Field name={`reSubmitMail.emailSubject`}>
                                    {({ field }: FieldProps) => (
                                      <Input
                                        maxLength={1000}
                                        showCount
                                        {...field}
                                        status={
                                          (props.touched.reSubmitMail?.emailSubject &&
                                            props.errors.reSubmitMail?.emailSubject &&
                                            "error") ||
                                          ""
                                        }
                                      />
                                    )}
                                  </Field>
                                  <Typography.Text type="danger">
                                    <ErrorMessage name={`reSubmitMail.emailSubject`} />
                                  </Typography.Text>
                                  <div style={{ marginBottom: "16px" }} />
                                  <Typography.Title
                                    level={5}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    Email Message
                                  </Typography.Title>
                                  <Field name={`reSubmitMail.emailMessage`}>
                                    {({ field }: FieldProps) => (
                                      <Input.TextArea
                                        rows={8}
                                        showCount
                                        maxLength={1000}
                                        style={{ height: "100px" }}
                                        {...field}
                                        status={
                                          (props.touched.reSubmitMail?.emailMessage &&
                                            props.errors.reSubmitMail?.emailMessage &&
                                            "error") ||
                                          ""
                                        }
                                      />
                                    )}
                                  </Field>
                                  <Typography.Text type="danger">
                                    <ErrorMessage name={`reSubmitMail.emailMessage`} />
                                  </Typography.Text>
                                </Form.Item>
                                <Typography.Title
                                  level={5}
                                  style={{ fontWeight: "bold" }}
                                >
                                  Cancel Email
                                </Typography.Title>
                                <Form.Item>
                                  <Typography.Title
                                    level={5}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    Email Subject
                                  </Typography.Title>
                                  <Field name={`cancelMail.emailSubject`}>
                                    {({ field }: FieldProps) => (
                                      <Input
                                        maxLength={1000}
                                        showCount
                                        {...field}
                                        status={
                                          (props.touched.cancelMail?.emailSubject &&
                                            props.errors.cancelMail?.emailSubject &&
                                            "error") ||
                                          ""
                                        }
                                      />
                                    )}
                                  </Field>
                                  <Typography.Text type="danger">
                                    <ErrorMessage name={`cancelMail.emailSubject`} />
                                  </Typography.Text>
                                  <div style={{ marginBottom: "16px" }} />
                                  <Typography.Title
                                    level={5}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    Email Message
                                  </Typography.Title>
                                  <Field name={`cancelMail.emailMessage`}>
                                    {({ field }: FieldProps) => (
                                      <Input.TextArea
                                        rows={8}
                                        showCount
                                        maxLength={1000}
                                        style={{ height: "100px" }}
                                        {...field}
                                        status={
                                          (props.touched.cancelMail?.emailMessage &&
                                            props.errors.cancelMail?.emailMessage &&
                                            "error") ||
                                          ""
                                        }
                                      />
                                    )}
                                  </Field>
                                  <Typography.Text type="danger">
                                    <ErrorMessage name={`cancelMail.emailMessage`} />
                                  </Typography.Text>
                                </Form.Item>
                              </Col>
                            </Row>
                          </div>
                        </>
                      )}
                      <Row>
                        <Col
                          xs={24}
                          md={24}
                          style={{ textAlign: "right" }}
                        >
                          <Button
                            htmlType="submit"
                            type="primary"
                            disabled={!props.isValid}
                          >
                            Submit
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Form>
              </>
            );
          }}
        </Formik>
        <SuccessModal
          title={`You have successfully ${id ? "edited the template" : "created a new template"} `}
          type={"success"}
          buttonText={"Go Back"}
          redirect={`/templates`}
          open={successOpen}
          setOpen={setSuccessOpen}
          message={""}
        />
      </ContentWrapper>
      <Modal
        title="Confirm Update"
        open={isModalVisible}
        confirmLoading={isSubmitLoading}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <p>Are you sure you want to edit the template?</p>
      </Modal>
    </>
  );
};
